// Return-visit reminders (admin-only). The map mirrors the server; set/clear echo the
// full map back so the bell badge is always consistent after a write.
import { computed, signal } from '@preact/signals';
import { apiGet, apiPost } from '../lib/api';
import { todayISO } from '../lib/dates';

export interface ReminderRec {
  date: string; // YYYY-MM-DD
  note: string;
  address: string;
  development: string;
  at: string;
}

export const reminders = signal<Record<string, ReminderRec>>({});

export const dueCount = computed(() => {
  const today = todayISO();
  return Object.values(reminders.value).filter((r) => r.date && r.date <= today).length;
});

export async function fetchReminders(): Promise<void> {
  const res = await apiGet<{ reminders: Record<string, ReminderRec> }>('/api/reminders');
  reminders.value = res.reminders;
}

export async function setReminder(
  id: string,
  fields: { date: string; note: string; address: string; development: string },
): Promise<boolean> {
  try {
    const res = await apiPost<{ reminders: Record<string, ReminderRec> }>('/api/reminders', {
      action: 'set',
      id,
      ...fields,
    });
    reminders.value = res.reminders;
    return true;
  } catch {
    return false;
  }
}

export async function clearReminder(id: string): Promise<boolean> {
  try {
    const res = await apiPost<{ reminders: Record<string, ReminderRec> }>('/api/reminders', {
      action: 'clear',
      id,
    });
    reminders.value = res.reminders;
    return true;
  } catch {
    return false;
  }
}
